module.exports = __webpack_public_path__ + "static/media/delux01.48b006c0.png";